import {h, Component} from 'preact'
import {connect} from 'react-redux'

import reduce from '../reducers'
import store from '../store'
import * as actions from '../actions'
import Renderer from '../canvas/renderer'

import constants from '../constants'
import util from '../util'

import designService from '../service/designService'
import designDomain from '../domain/designDomain'
import statsService from '../service/statsService'
import ConfigureTemplateModal from "./ConfigureTemplateModal";
import CleanUploadsModal from "./CleanUploadsModal";

export default @connect(reduce, actions)
class AppAdmin extends Component {
  constructor() {
    super();

    this.state = {
      isCleanUploadsModal: false
    };

    this.showCollections = () => {
      this.props.showCollections(true);
    };

    this.showTemplates = (status) => {
      const filters = {
        page: 0,
        pageSize: 100,
        status: status.id,
        orderBy: 'name',
        orderByDirection: 'asc',
      };

      this.props.showPromos();
      this.props.setPromoDesigns([], true);
      this.props.setStatusFilter(status.id);

      designService.getTemplates(filters).then(response => {
        const designs = response.data.map(design => new designDomain.Design(design, util.sizes));
        this.props.setPromoDesigns(designs);
      });
    };

    this.showRemovedTemplates = (status) => {
      this.props.setPromoLoading(true);
      this.props.showPromos();
      designService.getRemovedTemplates().then(response => {
        const designs = response.data.map(design => new designDomain.Design(design, util.sizes));
        this.props.setPromoDesigns(designs);
      });
    };

    this.toggleRuler = () => {
      Renderer.toggleRuler();
    };

    this.showConfigureTemplateModal = () => {
      this.props.showConfigureTemplateModal();
    };

    this.onConfigureTemplateModalClose = () => {
      this.props.hideConfigureTemplateModal();
    };

    this.goToStats = () => {
      window.open(constants.appPrefix + '/stats');
    };

    this.refreshThumbnail = () => {
      if (confirm('Are you sure?')) {
        designService.refreshThumbnail(this.props.designId).then(() => {
          alert('Done!');
        })
      }
    };

    this.viewLongtail = () => {
      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      designService.updateDesignHtml({
        id: this.props.designId,
        html: Renderer.getPagesContent(),
        hasVideo: store.getState().hasVideo
      }).then(response => {
        this.props.setIsSaved(true);
        this.props.setIsSaving(false);

        const name = this.props.designName.toLowerCase().replace(/ /g, '-');
        window.open('/' + util.getLongtailType(this.props.designSize) + '-template/' + name + '.html', '_blank').focus();
      })
    }
  }

  closeCleanUploadsModal() {
    this.setState({isCleanUploadsModal: false})
  }

  openCleanUploadsModal() {
    this.setState({isCleanUploadsModal: true})
  }

  componentDidMount() {
    if (this.props.isAdmin || this.props.isDesigner || this.props.isWriter) {
      statsService.getBucketsCount().then(response => {
        this.props.setBucketCount(response.data)
      })
    }
  }

  render(props, state) {
    if (!props.isAdmin && !props.isDesigner && !props.isWriter) return null;

    let label = '';
    if (props.isAdmin) label = 'Admin';
    else if (props.isDesigner) label = 'Designer';
    else if (props.isWriter) label = 'Writer';
    label = label + ' mode';

    if (props.isTemplate) {
      label += ' | Editing template'
    }

    let statuses = [];
    if (this.props.isAdmin) statuses = constants.statuses;
    else if (this.props.isDesigner) statuses = constants.designerStatuses;
    else if (this.props.isWriter) statuses = constants.writerStatuses;

    let viewTemplateOptions = statuses.map(status =>
      <li>
        <a onClick={() => this.showTemplates(status)}>
          {status.label} ({props[status.label.toLowerCase().replace(' ', '') + 'Count']})
        </a>
      </li>
    );

    return (<div className="app-admin">
      <div className="logo">
        {label}
      </div>
      <nav className="actions">
        <ul>
          <li className={props.isTemplate ? '' : 'hidden'}>
            <a onClick={this.showConfigureTemplateModal}>Configure</a>
          </li>

          {props.isAdmin && <li><a onClick={this.openCleanUploadsModal.bind(this)}>Clean Uploads</a></li>}

          <li className={props.isWriter ? 'hidden' : ''}>
            <a onClick={this.goToStats}>Stats</a>
          </li>
          <li className={props.isTemplate ? '' : 'hidden'}>
            <a onClick={this.refreshThumbnail}>Refresh Thumbnail</a>
          </li>
          <li className={props.isTemplate && this.props.designStatus === 'published' ? '' : 'hidden'}>
            <a onClick={this.viewLongtail}>Preview Longtail</a>
          </li>
          <li className={!props.isAdmin ? 'hidden' : ''}>
            <a onClick={() => this.showCollections()}>Template Collections</a>
          </li>
          <li>
            <div className="dropdown">
              <a className="dropdown-toggle">View Templates</a>
              <div className="dropdown-menu">
                <div className="angle right"/>
                <ul>
                  <li className={!props.isAdmin ? 'hidden' : ''}>
                    <a onClick={() => this.showRemovedTemplates()}>Removed</a>
                  </li>
                  {viewTemplateOptions}
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </nav>

      <CleanUploadsModal open={state.isCleanUploadsModal} onClose={this.closeCleanUploadsModal.bind(this)}/>

      <ConfigureTemplateModal
        open={props.isConfigureTemplateModal}
        onModalClose={this.onConfigureTemplateModalClose}
      />
    </div>)
  }
}
